import { render, staticRenderFns } from "./DoubleVisitReport.vue?vue&type=template&id=38d58204&scoped=true"
import script from "./DoubleVisitReport.vue?vue&type=script&lang=js"
export * from "./DoubleVisitReport.vue?vue&type=script&lang=js"
import style0 from "./DoubleVisitReport.vue?vue&type=style&index=0&id=38d58204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d58204",
  null
  
)

export default component.exports